import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PreviousLegalDocumentsState, previousLegalDocumentsFeatureKey } from '../reducers/legal-documents-previous.reducer';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import * as previousLegalDocumentsState from '../reducers/legal-documents-previous.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeePreviousState = createFeatureSelector<fromEmployeeMainReducer.State, PreviousLegalDocumentsState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Previous Legal Documents SUB STATE
export const getPreviousLegalDocumentsState = createSelector(
  getMainEmployeePreviousState,
  state => state[previousLegalDocumentsFeatureKey]
);
//#endregion

//#region Previous Legal Documents SELECTORS
export const getPreviousLegalDocumentsRequest = createSelector(
  getPreviousLegalDocumentsState,
  previousLegalDocumentsState.getPreviousLegalDocumentsRequest
);
export const getPreviousLegalDocumentsSuccess = createSelector(
  getPreviousLegalDocumentsState,
  previousLegalDocumentsState.getPreviousLegalDocumentsResponse
);
export const getPreviousLegalDocumentsFailure = createSelector(
  getPreviousLegalDocumentsState,
  previousLegalDocumentsState.getPreviousLegalDocumentsFailure
);
//#endregion
